<template>
    <ul class="rounded-6 overflow-hidden border border-primary-20">
        <li
            class="bg-white odd:bg-primary-5 p-12"
            :key="item.id ?? index"
            v-for="(item, index) in items"
        >
            <div class="flex items-center justify-between gap-8">
                <span class="truncate" v-if="!!labelByLanguage(item[label])">
                    {{ labelByLanguage(item[label]) }}
                </span>
                <label-with-missing-translation v-else />

                <div class="flex items-center gap-8" v-if="hasActions">
                    <button
                        class="text-primary-80 hover:text-primary"
                        v-if="!hideShow"
                        @click="$emit('show', item)"
                    >
                        <svg-icon type="visibility"/>
                    </button>
                    <button
                        class="text-primary-80 hover:text-primary"
                        v-if="!hideEdit"
                        @click="$emit('edit', item)"
                    >
                        <svg-icon type="edit"/>
                    </button>
                    <button
                        class="text-primary-80 hover:text-primary"
                        v-if="!hideDuplicate"
                        @click="$emit('duplicate', item)"
                    >
                        <svg-icon type="content-copy"/>
                    </button>
                    <button
                        class="text-primary-80 hover:text-semantic-error"
                        v-if="!hideDelete"
                        @click="$emit('delete', item)"
                    >
                        <svg-icon type="delete"/>
                    </button>
                    <button
                        class="draggable cursor-grab text-primary-80 hover:text-primary"
                        v-if="draggable"
                    >
                        <svg-icon type="drag-indicator"/>
                    </button>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
import SvgIcon from "./SvgIcon.vue";
import LabelWithMissingTranslation from "../LabelWithMissingTranslation.vue";
import _debounce from "lodash/debounce";
import {mapState} from "pinia";
import {useMainStore} from '../../state/store';

export default {
    name: "AlternatingList",
    components: {
        LabelWithMissingTranslation,
        SvgIcon
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        hideShow: Boolean,
        hideEdit: Boolean,
        hideDuplicate: Boolean,
        hideDelete: Boolean,
        draggable: Boolean,
        translatable: Boolean,
        label: String,
    },
    computed:{
        ...mapState(useMainStore, ['locale']),
        hasActions() {
            return !this.hideShow || !this.hideEdit || !this.hideDuplicate || !this.hideDelete || this.draggable;
        },
    },
    methods: {
        labelByLanguage(label) {
            if (this.translatable) {
                return label[this.locale]
            } else {
                return label
            }
        }
    }
}
</script>
<style scoped>

</style>
